module.exports = __webpack_public_path__ + "img/benefits-emp_assist.4ba97883.jpg";